import { TuiMultiSelectComponent } from '@taiga-ui/kit';
import { Directive, inject } from '@angular/core';

@Directive({
  selector: '[issDoNotClearOnSearch]',
  standalone: true,
})
export class DoNotClearOnSearchDirective<T> {
  private readonly multiselect = inject<TuiMultiSelectComponent<T>>(TuiMultiSelectComponent);

  public constructor() {
    const multiselect = this.multiselect as unknown as { updateSearch: (search: string | null) => void };

    multiselect.updateSearch = function (this: TuiMultiSelectComponent<T>, search: string | null): void {
      if (this.search === search || search == null) {
        return;
      }

      this.search = search;
      this.searchChange.emit(search);
    };
  }
}
